import { useQuery } from '@tanstack/react-query';
import * as MH from 'mh-client';
import { getApiClient } from '../../lib/apiClient';

interface UseVersionOptions {
    enabled?: boolean;
}

/**
 * Hook for fetching the API version.
 */
export function useVersion(options?: UseVersionOptions) {
    const client = getApiClient();

    return useQuery({
        queryKey: ['version'],
        queryFn: async (): Promise<MH.VersionResponse> => {
            return await client.version.get();
        },
        enabled: options?.enabled,
    });
}
